import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, initPlausible, trackPageView } from '../utils/analytics';
import { recordAuthenticatedDailyVisit } from '../utils/firstPartyAnalytics';

/**
 * Initializes explicitly configured optional analytics and records route views
 * only for providers that were enabled. Authenticated first-party visit
 * measurement remains independent. Renders nothing.
 */
export default function Analytics({ authenticated = false }: { authenticated?: boolean }): null {
  const location = useLocation();

  useEffect(() => {
    initGA();
    initPlausible();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  useEffect(() => {
    if (authenticated) recordAuthenticatedDailyVisit();
  }, [authenticated]);

  return null;
}
